export default {
    site: {
        common: {
            hello: "Hello",
            thankYou: "Спасибо",
            forMoreInfo: "для доп. информации",
            hoverOverColumnHeaders: "Проведите мышью над заголовками колонок для подробной информации.",
            username: "Имя пользователя",
            score: "Счет",
            points: "Очки",
            pointsAbbreviation: "Очки", //don't have such in RU, only full name + different ending for different numbers (1 очко 2 очка 5 очков...)
            chapter: "Глава",
            tier: "Категория", //seems official translation, but not sure it's even used by players, may be it's better to use plain "Tier"
            t1: "T1",
            t2: "T2",
            t3: "T3",
            collectionsPerDay: "Сборов в день",
            relicBoostPercent: "Усиление реликвиями %",
            mountainHallPercentShort: "Горки, %", // used in table heading keep it short.
            updated: "обновлено",
            lastUpdated: "Последнее обновление",
            created: "создано",
            role: "роль",
            Fellow: 'Союзник',
            Ambassador: 'Посол',
            Mage: 'Маг',
            Archmage: 'Архимаг',
            saveChanges: "Сохранить изменения",
            copy: "Копировать",
            close: "Закрыть",
            cancel: "Отмена",
            action: "Действие",
            date: "Дата",
            Left: "Покинул",
            Joined: "Присоединился",
            human: "Человек",
            elf: "Эльф",
            search: "Поиск",
            enter: "Введите",
            yes: "Да",
            no: "Нет",
            tournament: "Турнир",
            tournaments: "Турниры",
            fellowship: "Союз",
            player: "Игрок",
            member: "Союзник",
            history: "История",
            tournamentHistory:  "История турниров",
            scoreHistory: "История рейтинга",
            server: "Сервер",
            lastWeekGain: "Получено за последнюю неделю",
            comingSoon: "Скоро сделаем...",
            chest: "сундук",
            yourServer: "Ваш Сервер",
            allServers: "Все Серверы",
            boosts: "Усиления",
            marble: "мрамор",
            steel: "сталь",
            planks: "доски",
            crystal: "хрусталь",
            scrolls: "свитки",
            silk: "шелк",
            elixir: "эликсир",
            magic_dust: "маг. пыль",
            gems: "самоцветы",
            sentient: "разумные",
            goods: "товары",
            average: "среднее",
            expansions: 'Расширения', // 5x5 grids
            cultureBoostMinimum: 'Мин. бонус культуры',
            cultureBoostCalculated: 'Расчетный бонус культуры',
            neighborlyHelp: 'Соседская помощь',
            neighborlyHelpAbbreviation: 'СП'
        },
        // HIGH PRIORITY
        nav: {
            home: "Главная",
            players: "Игроки",
            fellowships: "Союзы",
            tournaments: "Турниры",
            contact: "Контакты",
            donate: "Пожертвования",
            faq: "FAQ",
            news: "Новости",
            privacyPolicy: "Политика конфиденциальности",
            me: "Я",
            myFellowship: "Мой Союз",

            // NOTE USED AT THE MOMENT
            globalStats: "Глобальная статистика",
            articles: "Статьи",
            fellowshipAdventure: "Приключения Союзов",
            recruit: "Набор",
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Посмотреть город на ElvenArchitect"
            ,obtainingLink: "Получение ссылки"
            ,successMessage: "Успешно! Кликните по ссылке ниже для просмотра города на Elven Architect"
            ,ageOfLink: "Ссылка показывает состояние города на: "
            ,clickToGetCurrentCity: "<-- Нажмите для получения текущего состояния города",
        },
        // High Priority
        playerSelection: {
            headline: "Просмотр сайта как",
            description: "Это обновит различные части сайта, которые могут быть настроены для пользователя. Например: мой союз, моя страница, страницы турниров и рангов.",
            youAreViewing: `Просмотр сайта как {username} с сервера {serverName}.`,
            changeUser: "Смена Игрока",
            enterYourUsernameToGetStarted: "Введите ваше имя пользователя в Elvenar чтобы начать работу с сайтом",
            thisIsNotASignup:"Это не создание учетной записи. Вводя имя пользователя вы просто настраиваете сайт под себя. Есть много серверов Elvenar, и мы покажем рейтинг вашего сервера. Так же будут доступны ссылки на ваш союз и персональную страницу"
        },
        searchBoxes: {
            enterFellowshipName: 'Введите имя Союза',
            instructions: "Введите имя и выберите один из списка.",
            noFellowship: "Нет Союза",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "д. назад",
            minsAgo: "мин. назад",
            hoursAgo: "ч. назад",
            justNow: "только что",
            never: "Никогда",
        },
        home: {
            welcome: "Добро пожаловать на Elven Stats!",
            youAreViewing: "Вы просматриваете сайт как {username} с сервера {serverName}",
            youCanChange: "Вы можете сменить пользователя, кликнув на аватар в правом верхнем углу или посетив <router-link to='/contact'>эту страницу</router-link>",
            features: {
                headline: "Возможности",
                fellowshipAdministration: {
                    headline: "Администрирование Союза <strong>СТАЛО ПРОЩЕ</strong>",
                    bullet1: "Автоматическое отслеживание производства усиленных товаров поможет вам лучше балансировать ваш союз",
                    bullet2: "Автоматическое отслеживание/еженедельный отчет, включающий рейтинг, участие в турнирах, месячный рост и мотивирующие \"Достижения\" и персональные рекорды",
                    bullet3: "Помогает отслеживать дисбаланс производства союзников, типа некорректного соотношения товаров разных категорий",
                },
                elvenArchitectIntegration: {
                    headline: "<strong>Интеграция</strong> с ElvenArchitect",
                    description: "Загрузите ваш город в ElvenArchitect точно таким какой он есть за секунды! Используйте это для лучшего планирования следующей большой перестройки города или найдите место, которое вы раньше не замечали! Ищите лого ElvenArchitect на страницах игроков."
                },
                advancedRankingLists: {
                    headline: "Расширеные <strong>Рейтинги</strong>",
                    bullet1: "Рейтинг по открытым расширениям (для сравнения себя с людьми, находящимися на том же уровне)",
                    bullet2: "Просмотр усилений, главы и прочего в списках игроков.",
                },
                fellowshipTournamentTracking: {
                    headline: "<strong>Отслеживание</strong> турниров в разрезе Союзов",
                    description: "Посмотрите, как ваш союз выглядит на фоне других. Вызовите другие союзы на дуэль для дружеского соревнования!",
                },
                matchMaking: {
                    headline: "<strong>Поиск</strong> подходящих игроков/союзов",
                    description: "ElvenStats отслеживает усиления игроков и уровни производства в союзах. С этой информацией, союзы могут приглашать правильных кандитатов для балансировки товаров. Игроки, ищущие союз могут найти союзы, которые действительно НУЖДАЮТСЯ в их усилениях. Сохраняет время и снижает количество отказов!"
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Рейтинг",
                points: "Очки",
                medianUserScore: "Средний <strong>счет игрока</strong>",
                memberCount: "<strong>Количество</strong> игроков",
            },
            barCharts: {
                clickSlice: "Кликните по столбцу для подробностей (по союзникам)",
                tier1: "Tier 1",
                tier2: "Tier 2",
                tier3: "Tier 3",
                drillDown: "Вернуться к {0}"
            },
            idealCandidate: {
                heading: "Идеальный кандидат",
                description: "Будет иметь счет {medianScore} и будет иметь одно или несколько из следующих усилений: {boosts}",
                note: "Некоторые комбинации усилений невозможны, см {0}"
            },
            memberGoodsTable: {
                heading: "Производство товаров союзниками",
                description: `Эта таблица рассчитывает, сколько каждого товара производится в вашем союзе. Мы делаем основанное на опыте предположение, какой уровень
                усиления у ваших союзников и по умолчанию предполагаем, что каждый игрок перезапускает фабрики 3 раза в день (2х9ч и 1х3ч).
                Для улучшения точности расчетов, спросите у ваших союзников точные значения и впишите их ниже. Вы можете сохранить все введенные данные и 
                увидеть их при следующей загрузке этой страницы. Диаграммы сверху автоматически обновятся после внесенных изменений.
                Проведите мышкой над заголовком столбца, чтобы увидеть подробную информацию об этом столбце.
                `,
                refreshButtonText: 'Обновить список союзников',
                refreshButtonTip: 'Это добавит новых союзников, удалит старых, обновит союзные звания и текущий счет.',
                inactiveWarningTip: 'Пользователь возможно неактивен, Счет последний раз обновлялся: {0}',
                collectsPerDayValidation: "Должно быть в интервале 1-6",
                boostPercentValidation: "Должно быть в интервале 40 - 700, не включая бонус от Горных Залов",
                perDayShort: "/день",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Счет игрока, учтите, что счет обновляется не в реальном времени, а несколько раз в неделю.",
                chapterTip: "Это глава, в которой находится игрок. Для справки: Элементали = 12, Полурослики = 11, и т.д.",
                boostTip: "Усиления игроков и количество ПРОИЗВОДИМОЕ в день.",
                collectsPerDayTip: `***РЕДАКТИРУЕТСЯ*** <br/>Сборов в день. Это количество перезапусков фабрик в сутки. Должно быть в интервале 1-6. 1 = 1x24ч, 2=2x9ч, 3=2x9ч + 1x3ч, 4=1x9ч + 3x3ч, 5=4x3ч + 1x9ч, 6=5x3ч + 1x9ч<BR/>См. FAQ для подробностей.`,
                relicBoostPercentTip: `***РЕДАКТИРУЕТСЯ***<br/> Процент усиления от реликвий, в интервале 40-700. Не должен включать в себя бонус от Горных Залов, который определяется автоматически и добавляется к этому числу`,
                mountainHallPercentTip: "Это процент усиления от Горных Залов, который мы определили для данного игрока. Используется совместно с % усиления для расчета суммарного усиления.",
                updatedTip: "Момент, когда город игрока был последний раз проанализирован. Этот процесс - то что задает усиления, данные для elven architect, рассчитывает производство всех фабрик, % от горных залов, и т.д. Данные города периодически обновляются автоматически, но вы можете принудительно обновить их нажатием на соответствующую кнопку.",

            },
            coinsAndSuppliesTable: {
                heading: "Производство монет/запасов",
                description: `Ключевая колонка здесь - "Запасов Осталось", т.к. она показывает, достаточно ли запасов производится игроком для поддержания производства 24/7.
                Используйте переключатели ниже для учета минимального бонуса культуры (без соседской помощи) и/или количества перезапусков фабрик в день (из таблицы выше). Выключение обоих полезно если вы 
                хотите увидеть, какая часть запасов связана с большим производством фабрик или с большим бонусом культуры. Так же учтите, что иметь небольшой (~10%) отрицательный остаток запасов - 
                нормально. Есть много способов, которыми игроки поддерживают свои запасы, такие как посещение соседей, производство запасов более короткими интервалами или использования заклинаний
                "Сила запасов". Думайте об отрицательном значении как о том, что вам нужно что-то из этого делать ежедневно для поддержания баланса.
                ВНИМАНИЕ: в данный момент производство войск не учитывается в использованных запасах (учитываются только товары 1, 2 и 3 категории), т.ч. возможно вам потребуется больше.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "мин бонус",
                made: "Сделано",
                used: "Потрачено",
                left: "Осталось",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: "Бонус культуры. Важно: это поле рассчитано исходя из отсутствия соседской помощи. В реальности бонус будет скорее всего больше.",
                moneyComputedTip: "Количество монет производимых в день, включая древние чудеса, производящие монеты",
                moneyUsedComputedTip: "Количество монет, тратящихся на производство товаров.",
                moneyRemainingComputedTip: "Монеты - Использованные монеты, это избыток или дефицит монет игрока за каждый день",
                suppliesComputedTip: "Количество запасов, производящееся, если все мастерские запускаются на сутки (Ящик инструментов) + все древние чудеса. (не включая сет бонусы)",
                suppliesUsedComputedTip: "Количество запасов, расходуемых на производство товаров. Не включает расход запасов на бараки! Смотри объяснение выше.",
                suppliesRemainingComputedTip: "Запасы - Использованные запасы, это избыток или дефицит запасов игрока за каждый день",
                manaTip: "Количество Маны производимое в 24 часа (не включает Драконий монастырь)",
            },
            popCultureTable: {
                heading: "Подробности культура/население",
                description: 'Таблица ниже показывает культуру/население для каждого союзника, наведите мышь на заголовки столбцов для доп.информации.',

                // Icon Sub-Headings
                minBoostPercent: "Мин усил. %",
                levels: "Уровни",
                total: "Всего",
                working: "Занято",
                available: "Доступно",
                required: "Требуется",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Суммарное количество уровней древних чудес игрока.",
                cultureBoostPercentTip: "Бонус культуры. Важно: это поле рассчитано исходя из отсутствия соседской помощи. В реальности бонус будет скорее всего больше.",
                totalPopulationTip: "Всего населения, производящегося вашими резиденциями,гибридами культура/население и древними чудесами",
                workingPopulationTip: "Занято населения - Количество, потребляемое зданиями.",
                availablePopulationTip: "Доступно населения",
                totalCultureTip: "Всего культуры, производящейся вашими культурными зданиями, гибридами культура/население и древними чудесами",
                requiredCultureTip: "Необходимо культуры для всех ваших зданий",
                availableCultureTip: "Доступная Культура",
            },
            cityCoverageTable: {
                heading: "Покрытие города",
                description: "Показывает сколько клеток занято в городе каждого союзника под здания определенного типа. Пустые клетки - клетки, которые сейчас не используются.",
                tiles: 'Клетки'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: "Еженедельный отчет на почту",
                description: "Мы автоматически создаем еженедельные отчеты, подходящие для того, чтобы поделиться ими с союзниками. Свежий отчет появляется каждое воскресенье (примерно в 20:00 UTC (23:00 MSK)) для прошедшей недели. Просто скопируйте текст ниже и вставьте!",
                selectReportHint: "Выбрать отчет для недели, заканчивающейся датой сверху",
                reportsAreOptimizedFor: "Отчеты оптимизированы для отображения в почтовой системе Elvenar, т.е. колонки располагаются настолько корректно, насколько это возможно, и имена обрезаются так, чтобы влезть в одно сообщение.",
                accolades: "достижения",
                tourneyChamp: " - Чемпион турнира (эта неделя): {0}",
                tourneyHero: " - Чемпион турниров (4 недели): {0}",
                highestGrowthPlusPercentage: " - Сильнейший рост (счет и процент): {0}",
                highestGrowthPoints: " - Сильнейший рост (счет): {0}",
                highestGrowthPercentage: " - Сильнейший рост (процент): {0}",
                highestGrowthError: " - Сильнейший рост: Не может быть определен пока, нет истории",
                newPersonalRecords: "Новые рекорды",
                userSetANewPersonalRecordFor: " * {0} новый рекорд: {1}",
                allMembersByPointGainThisWeek: "СОЮЗНИКИ по приросту счета (эта неделя)",
                tournamentPointsHeader: "Турнирные очки (эта неделя / ВСЕГО С {0})",
                top8ByPercentage: "ТОП 8 по % (эта неделя)",
                top8ByPointsSince: "ТОП 8 по очкам (с {0})",
                top8ByPercentageSince: "ТОП 8 по % (С {0})",
                reportGeneratedBy: "Отчет создан на elvenstats.com, подробнее на: ",
                mostPointsInAWeek: "Макс. очков за неделю",
                highestTournamentScore: "Макс. очков на турнире",
                highestTournamentRank: "Макс. рейтинг на турнире",
                insufficientHistoryForThesePlayers: "* Пропущено: {0} из-за маленькой истории. Будут включены на след. неделе",
                insufficientHistory1Week: "* Не хватает истории для этой секции, загляните на след. неделе!",
                insufficientHistory4Week: "* Не хватает истории для этой секции, нужно 4 недели. Попробуйте снова скоро!",
            },
            memberHistory: {
                heading: "История состава союза",
                noChangesDetected: "Нет изменений состава союза с момента начала отслеживания {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'У вас есть несохраненные изменения. Когда закончите редактировать союз - нажмите кнопку.',
                standbyImporting: 'Ожидайте: Мы импортируем некоторых ваших союзников, по которым нехватает информации',
                limitedHistory: "Мы совсем недавно начали отслеживать {0}, так что история ограничена. Каждое воскресенье недельные снимки будут представлены здесь, заходите посмотреть!",
                noChangesSinceTrackingBegan: "Нет изменений с начала отслеживания",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "История Союзов"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Обновления в реальном времени сейчас недоступны.",
            realTimeUpdatesNotAvailableDescription: "Эта ошибка обычно возникает после перезапуска игровых серверов для обновления или профилактики. Если это произошло, ElvenStats должен вручную переподключиться к серверу перед тем как информация будет доступна по запросу. Пожалуйста, повторите запрос через несколько часов. В остальном сайт полностью работоспособен в это время.",
            copyToClipboardSuccessful: "Удачно скопировано в буфер обмена!",
            copyToClipboardFailed: "Ошибка копирования, выделите полностью текстовое поле и нажмите CTRL+C",
            errorOccurredImporting: "Возникла ошибка. Загрузка ваших игроков.",
            errorOccurredImportingMessage: "Возникла ошибка во время загрузки ваших игроков. Пожалуйста, попробуйте еще раз. Если ошибка сохраняется - сообщите нам.",
            errorOccurredImportingWillNotBeAvailableInReports: "Пользователи, которые не были загружены не попадут в отчеты.",
            finishedSyncSuccessful: "Синхронизация успешно завершена!",
            playerIsAnonymous: "Игрок запретил показывать информацию о себе на elvenstats.com",
            inactiveWarningTip: "Игрок скорее всего неактивен, счет последний раз изменялся: {0}",
            isFriendTip: "Этот игрок - друг ElvenStats. Друзья потратили свое время или деньги для поддержки работы сайта!",
        },
    }
}


// WEBPACK FOOTER //
// ./src/lang/ru.js